import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { Schedule } from "@mui/icons-material";

/**
 * Schedule Trigger — Iniciar flow por agendamento (cron).
 *
 * data.scheduleType: "interval" | "cron" | "daily" | "weekly"
 * data.intervalMinutes: number — para type=interval
 * data.cronExpression: string — para type=cron (ex: "0 9 * * 1-5")
 * data.dailyTime: string — para type=daily (ex: "09:00")
 * data.weeklyDay: number — para type=weekly (0=Dom, 1=Seg, ..., 6=Sab)
 * data.weeklyTime: string — para type=weekly
 * data.timezone: string — (ex: "America/Sao_Paulo")
 *
 * Saida: handle "a" (default)
 */
const DAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];

const ScheduleTriggerNode = memo(({ id, data, isConnectable, selected }) => {
  const schedType = data?.scheduleType || "daily";

  const getScheduleLabel = () => {
    switch (schedType) {
      case "interval":
        return `A cada ${data?.intervalMinutes || "?"} minutos`;
      case "cron":
        return data?.cronExpression || "Cron nao definido";
      case "daily":
        return `Diariamente as ${data?.dailyTime || "09:00"}`;
      case "weekly": {
        const day = DAYS[data?.weeklyDay] || "?";
        return `${day} as ${data?.weeklyTime || "09:00"}`;
      }
      default:
        return "Agendamento nao configurado";
    }
  };

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Schedule />}
      title="Agendamento"
      color="#6A1B9A"
      bgColor="#F3E5F5"
      noTarget
      isConnectable={isConnectable}
      selected={selected}
      minWidth={210}
    >
      {/* Schedule type badge */}
      <div style={{
        display: "inline-block",
        background: "#6A1B9A", color: "#fff",
        borderRadius: 4, padding: "2px 8px",
        fontSize: 10, fontWeight: 700,
        marginBottom: 6,
        textTransform: "uppercase",
      }}>
        {schedType}
      </div>

      {/* Schedule description */}
      <div style={{
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: 6,
        padding: "5px 10px",
        fontSize: 12,
        fontWeight: 500,
        color: "#333",
      }}>
        {getScheduleLabel()}
      </div>

      {data?.timezone && (
        <div style={{ fontSize: 10, color: "#999", marginTop: 4 }}>
          {data.timezone}
        </div>
      )}
    </NodeWrapper>
  );
});

ScheduleTriggerNode.displayName = "ScheduleTriggerNode";
export default ScheduleTriggerNode;
